export class ClienteSearchModel {
  codiceComune?: string;
  comune:string;
  ragioneSociale?: string;
  partitaIva?: string;
  idStatoCliente?: number;
  raggio?: number;
  idSituazionePartite?: number;
  latitudinePosizione?: number;
  longitudinePosizione?: number;
  intornoAMe?: boolean;
  codiceCliente: string;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/clienti/cliente-search.model.ts